import React, { Component } from 'react'
import { Link } from 'react-router';
import { auth } from '../ThirdPartyIntegration/firebaseClient'
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import MenuIcon from 'material-ui-icons/Menu';
import Drawer from 'material-ui/Drawer';
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import AccountIcon from 'material-ui-icons/AccountCircle';
import FavoriteIcon from 'material-ui-icons/Favorite';
import ChatIcon from 'material-ui-icons/Chat';
import ExitToAppIcon from 'material-ui-icons/ExitToApp';
import Badge from 'material-ui/Badge';

const styleSheet = {
    root: {
        marginTop: 30,
        width: '100%',
    },
    flex: {
        flex: 1,
    },
    list: {
        width: 250,
        flex: 'initial',
    },
    listFull: {
        width: 'auto',
        flex: 'initial',
    }
};

class Header extends Component {
    constructor() {
        super();
        this.state = {
            uid: null,
            username: null,
            isDrawerOpen: false
        }

        // This binding is necessary to make `this` work in the callback
        this.onClickLogout = this.onClickLogout.bind(this);
        this.openDrawer = this.openDrawer.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
    }

    onClickLogout() {
        auth.signOut();
    }

    openDrawer() {
        this.setState({ isDrawerOpen: true });
    }

    closeDrawer() {
        this.setState({ isDrawerOpen: false });
    };

    render() {
        const menuLinkStyle = {
            textDecoration: 'none'
        }
        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton color="contrast" aria-label="Menu" onClick={this.openDrawer}>
                            <Badge badgeContent={10} color="accent">
                                <MenuIcon />
                            </Badge>
                        </IconButton>
                        <img src="/logo48.png" alt="NDA" style={{ marginLeft: '1%' }} />
                    </Toolbar>
                </AppBar>
                <div>
                    <Drawer
                        open={this.state.isDrawerOpen}
                        onRequestClose={this.closeDrawer}
                        onClick={this.closeDrawer}
                    >
                        <List>
                            <Link style={menuLinkStyle} to="/loggedin/date">
                                <ListItem>
                                    <ListItemIcon>
                                        <FavoriteIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Date" />
                                </ListItem>
                            </Link>
                            <Link style={menuLinkStyle} to="/loggedin/matches">
                                <ListItem>
                                    <ListItemIcon>
                                        <Badge badgeContent={10} color="accent">
                                            <ChatIcon />
                                        </Badge>
                                    </ListItemIcon>
                                    <ListItemText primary="Matches" />
                                </ListItem>
                            </Link>
                            <Link style={menuLinkStyle} to="/loggedin/profile">
                                <ListItem>
                                    <ListItemIcon>
                                        <AccountIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Profile" />
                                </ListItem>
                            </Link>
                            <Divider />
                            <ListItem onClick={this.onClickLogout}>
                                <ListItemIcon>
                                    <ExitToAppIcon />
                                </ListItemIcon>
                                <ListItemText primary="Logout" />
                            </ListItem>
                        </List>
                    </Drawer>
                </div>
            </div>
        )
    }
}

export default withStyles(styleSheet)(Header);


// WEBPACK FOOTER //
// ./src/Components/Header.jsx